/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { KeyMapping } from "../keyboard-setting/keyboard-setting.service";

export abstract class KeyMappingStorageService {
   public abstract isPrefLimitationExist();
   public abstract saveKeyMapping(keyMappingSetting: string);
   public abstract getKeyMapping();
   constructor() {}
}
